export enum POEditorProperty {
  required = 'required',
  hidden = 'hidden',
  notRequired = 'notRequired',
  notHidden = 'notHidden',
}
